import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";

const CrmImportHeader: React.FC = () => {
  return (
    <Flex className={styles.headerContainer}>
      <Flex flexDirection="column" className={styles.headerContent}>
        <Flex alignItems="center" gap={Sizes.MD} className={styles.titleContainer}>
          <Flex className={styles.iconContainer} alignItems="center" justifyContent="center">
            <Icon type="upload" size="large" color={Colors.Neutral0} />
          </Flex>
          <Flex flexDirection="column" className={styles.textContainer}>
            <Text variant="h1" color={Colors.Neutral900} className={styles.title}>
              CRM Data Import
            </Text>
            <Text variant="regular-lg" color={Colors.Neutral600} className={styles.subtitle}>
              Import and validate data for Juniper Square CRM
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CrmImportHeader;
